<template>
  <v-dialog v-model="display" :width="dialogWidth">
    <template v-slot:activator="{ on }">
      <v-text-field
        v-bind="textFieldProps"
        :disabled="disabled"
        :loading="loading"
        :label="label"
        :value="formattedDatetime"
        @input="updateDateAndTime"
        :outlined="outlined"
        :rules="dateTimeRules"
        :dense="dense"
        :hide-details="hideDetails"
      >
        <template v-slot:append>
          <v-btn
            v-on="on"
            tile
            color="primary"
            small
            depressed
            class="ma-0 mb-1"
          >
            <v-icon> event </v-icon>
            <v-icon> schedule </v-icon>
          </v-btn>
        </template>
      </v-text-field>
    </template>
    <v-card>
      <v-card-text class="px-0 py-0">
        <v-tabs fixed-tabs v-model="activeTab">
          <v-tab key="calendar">
            <slot name="dateIcon">
              <v-icon>event</v-icon>
            </slot>
          </v-tab>
          <v-tab key="timer" :disabled="dateSelected">
            <slot name="timeIcon">
              <v-icon>access_time</v-icon>
            </slot>
          </v-tab>
          <v-tab-item key="calendar">
            <v-date-picker
              v-model="date"
              v-bind="datePickerProps"
              @input="showTimePicker"
              full-width
            ></v-date-picker>
          </v-tab-item>
          <v-tab-item key="timer">
            <v-time-picker
              ref="timer"
              class="v-time-picker-custom"
              format="24hr"
              v-model="time"
              v-bind="timePickerProps"
              full-width
            ></v-time-picker>
          </v-tab-item>
        </v-tabs>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <slot name="actions" :parent="this">
          <v-btn color="grey lighten-1" text @click.native="clearHandler">{{
            clearText
          }}</v-btn>
          <v-btn color="blue darken-1" text @click="okHandler">{{
            okText
          }}</v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment'

const DEFAULT_DATE = ''
const DEFAULT_TIME = '00:00:00'
const DEFAULT_DIALOG_WIDTH = 340
const DEFAULT_CLEAR_TEXT = 'CLEAR'
const DEFAULT_OK_TEXT = 'OK'

export default {
  name: 'exo-datetime-picker',
  model: {
    prop: 'datetime',
    event: 'input'
  },
  props: {
    datetime: {
      type: [Date, String],
      default: null
    },
    disabled: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    label: {
      type: String,
      default: ''
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    dialogWidth: {
      type: Number,
      default: DEFAULT_DIALOG_WIDTH
    },
    clearText: {
      type: String,
      default: DEFAULT_CLEAR_TEXT
    },
    okText: {
      type: String,
      default: DEFAULT_OK_TEXT
    },
    textFieldProps: {
      type: Object
    },
    datePickerProps: {
      type: Object
    },
    timePickerProps: {
      type: Object
    }
  },
  data() {
    return {
      display: false,
      okIsClicked: false,
      activeTab: 0,
      date: DEFAULT_DATE,
      time: DEFAULT_TIME,
      initMissionStartDate: null,
      updatedMissionStartDate: null,
      dateTimeRules: [
        (value) => value == '' || moment.utc(value).isValid() || 'Invalid date'
      ]
    }
  },
  mounted() {
    this.init()
  },

  computed: {
    formattedDatetime() {
      return this.selectedDatetime && !isNaN(this.selectedDatetime)
        ? this.selectedDatetime.toISOString()
        : ''
    },
    selectedDatetime() {
      if (this.date && this.time) {
        let datetimeString = this.date + ' ' + this.time
        if (this.time.length === 5) {
          datetimeString += ':00'
        }
        this.updatedMissionStartDate = datetimeString
        if (this.okIsClicked) {
          return moment.utc(datetimeString)
        } else {
          return moment.utc(this.initMissionStartDate)
        }
      } else {
        return null
      }
    },
    dateSelected() {
      return !this.date
    }
  },
  methods: {
    updateDateAndTime(input) {
      if (input === '') {
        this.clearHandler()
        return
      }
      input = new Date(input)
      let valid = moment.utc(input).isValid()
      if (!valid) {
        return
      }
      this.date = moment.utc(input).format('YYYY-MM-DD')
      this.time = moment.utc(input).format('HH:mm:ss')
      this.$emit('input', new Date(input).toISOString())
    },
    init() {
      if (!this.datetime) {
        return
      }
      if (isNaN(moment.utc(this.datetime))) {
        return
      }
      this.date = moment.utc(this.datetime).format('YYYY-MM-DD')
      this.time = moment.utc(this.datetime).format('HH:mm:ss')
      this.initMissionStartDate = this.date + ' ' + this.time
      this.updatedMissionStartDate = this.date + ' ' + this.time
    },
    okHandler() {
      this.okIsClicked = true
      this.resetPicker()
      this.initMissionStartDate = this.updatedMissionStartDate
      this.$emit('input', new Date(this.selectedDatetime).toISOString())
      this.okIsClicked = false
    },
    clearHandler() {
      this.resetPicker()
      this.date = DEFAULT_DATE
      this.time = DEFAULT_TIME
      this.initMissionStartDate = null
      this.updatedMissionStartDate = null
      this.$emit('input', null)
    },
    resetPicker() {
      this.display = false
      this.activeTab = 0
      if (this.$refs.timer) {
        this.$refs.timer.selectingHour = true
      }
    },
    showTimePicker() {
      this.activeTab = 1
    }
  },
  watch: {
    datetime: function () {
      this.init()
    }
  }
}
</script>
